import * as yup from "yup";

import { AccountOrBankDetailsValidationSchema, isEmpty } from "./validator";
import {
	BackdropCircularProgress,
	EnhancedButtonPrimeReact,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
	TwoColumnLayout,
} from "@websential/cosmic-v20";
import { Box, Grid, Typography } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import React, { useEffect, useMemo, useState } from "react";
import { setSelectedAccountant, signInUpdate } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery } from "@tanstack/react-query";

import { AccountOrBankDetailsSetupFieldsPanel } from "./Panels/AccountOrBankDetailsSetupFieldsPanel";
import { AccountOrBankDetailsToolbar } from "./AccountOrBankDetailsToolbar";
import { AccountantBankInfoSetupFieldsPanel } from "./Panels/AccountantBankInfoSetupFieldsPanel";
import { AuthService } from "../../services";
import { BankService } from "../../services/BankService";
import { CountryService } from "../../services/common/CountryService";
import { IAppState } from "../../store/reducers";
import {
	INITIAL_SNACKBAR_DATA,
} from "../../common/constants";
import { VerifyBankDialogue } from "../VerifyBankDialogue";
import { scrollPanelFieldsToTop } from "../../common/Common";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

const useGetCountryDDL = () =>
	useQuery({
		queryKey: ["country-ddl"],
		queryFn: () => CountryService.getCountryDDL(),
		refetchOnWindowFocus: false,
	});

// const useGetData = () =>
// 	useQuery({
// 		queryKey: ["account-bank-data"],
// 		queryFn: () => {
// 			return AuthService.getPADAgreenmentBankDetails();
// 		},
// 		refetchOnWindowFocus: false,
// 	});
export interface IAccountOrBankDetails { }
export const AccountOrBankDetails: React.FC<IAccountOrBankDetails> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [isPendingData, setIsPendingData] = useState(false);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	// [Verify]
	const [openVerifyBankDialogue, setOpenverifyBankDialogue] = useState(false)
	const [defaultSelectedCountryState, setDefaultSelectedCountryState] = useState("")

	const { isPending: isPendingCoutryDDL, data: countryList } = useGetCountryDDL();
	// const { isPending, data: accOrBankDetailsData }: any = useGetData();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const userIdStore = useSelector((state: IAppState) => state.user.profile.userId);
	const companyAccountantName = useSelector(
		(state: IAppState) => state.user.profile.companyAccountantName
	);
	const lastBankScreen = useSelector(
		(state: IAppState) => state.user.profile.lastBankScreen
	);
	useEffect(() => {
		if (companyAccountantName !== null && isAdminUser === 100) {
			formMethods.setValue('accTitle', companyAccountantName)
		}
	}, [companyAccountantName])

	// useEffect(() => {
	// 	if (accOrBankDetailsData) {
	// 		// formMethods.setValue(
	// 		// 	"transactionAlertEmail",
	// 		// 	accOrBankDetailsData?.transactionAlertEmail ?? undefined
	// 		// );
	// 	}
	// }, [accOrBankDetailsData])
	const { isPending: isSubmitting, mutate: saveAccountOrBankDetailsFieldsData } =
		useMutation({
			mutationFn: AuthService.saveAccountDetails,
			onSuccess: (res: IServerError | IResponse | any) => {
				if (res.status === 200 || res.status === 201) {
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// if (companyAccountantName !== null) {
					// 	dispatch(
					// 		signInUpdate({
					// 			user: { companyAccountantName: null },
					// 		})
					// 	);
					dispatch(setSelectedAccountant({ id: res.data.id, AccountantName: res.data.accTitle, status: res.data.status === 100 ? "Active" : "Inactive" }));
					// }
					// let path = `/account-bank-details`;
					// navigate(path);
					const [
						accountNo,
						branchTransitNumber,
						bankFinancialNo,
						transactionAlertEmail
					] = formMethods.watch([
						"accountNo",
						"branchTransitNumber",
						"bankFinancialNo",
						"transactionAlertEmail"
					]);
					const bankPayload = {
						accountantId: res.data.id,
						accountNo: accountNo ?? undefined,
						branchTransitNumber: branchTransitNumber ?? undefined,
						bankFinancialNo: bankFinancialNo ?? undefined,
						transactionAlertEmail: transactionAlertEmail ?? undefined,
						primaryAccount: false,
						status: 200

					};
					if (accountNo && accountNo !== null && accountNo !== "") {
						saveBankDetailsFieldsData(bankPayload);
					} else {
						scrollPanelFieldsToTop();
						(async () => {
							try {
								setIsPendingData(true)
								const response = await AuthService.lastBankScreen(userIdStore, 300);  //Client List
								dispatch(
									signInUpdate({
										user: { companyAccountantName: null, lastBankScreen: 300 },
									})
								);
							} catch { setIsPendingData(false) } finally { setIsPendingData(false) }
						})();
					}
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const { isPending: isSubmittingBankDetails, mutate: saveBankDetailsFieldsData } =
		useMutation({
			mutationFn: AuthService.saveBankDetails,
			onSuccess: (res: IServerError | IResponse | any) => {
				if (res.status === 200 || res.status === 201) {
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// let path = `/account-bank-details`;
					// navigate(path);
					// navigate("/pad-agreement")
					if (lastBankScreen && lastBankScreen !== 300) {
						// alert("go to pad");
						(async () => {
							try {
								setIsPendingData(true)
								const response = await AuthService.lastBankScreen(userIdStore, 100);  //PAD

							} catch { setIsPendingData(false) } finally { setIsPendingData(false) }
						})();
						dispatch(
							signInUpdate({
								user: { companyAccountantName: null },
							})
						);
						dispatch(
							signInUpdate({
								user: { lastBankScreen: 100 },
							})
						);
					}
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const DEFAULT_VALUES = {
		accTitle: undefined,
		firstName: undefined,
		lastName: undefined,
		initial: undefined,
		phone: undefined,
		fax: undefined,
		email: "",
		addressLine1: undefined,
		// country: undefined,
		province: undefined,
		postCode: undefined,

		accountNo: undefined,
		branchTransitNumber: undefined,
		bankFinancialNo: undefined,
		transactionAlertEmail: undefined,
	};

	const formMethods = useForm<any>({
		resolver: yupResolver(AccountOrBankDetailsValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES
	});

	const [openBranchAddedDialog, setOpenBranchAddedDialog] = useState(false);
	const [pendingValues, setPendingValues] = useState<any>(null);
	const onCloseBranchAddedHandler = () => {
		setOpenBranchAddedDialog(false)
	}
	const onConfirmBranchSubmit = async () => {
		if (pendingValues) {
			setOpenBranchAddedDialog(false);
			setPendingValues(null);
			const SelectedCountry = countryList.find(
				(e: any) => e.value === pendingValues.country
			);
			try {
				setIsPendingData(true);
				const ProvinceOrStateDDL = await AuthService.getProvinceOrStateDDL(
					SelectedCountry.value,
					SelectedCountry.countryType
				);
				const selectedProvinceOrState = pendingValues.province
					? ProvinceOrStateDDL.find((e: any) => e.value === pendingValues.province)
					: pendingValues.state
						? ProvinceOrStateDDL.find((e: any) => e.value === pendingValues.state)
						: undefined;

				let payload = {
					accTitle: pendingValues.accTitle,
					firstName: pendingValues.firstName,
					lastName: pendingValues.lastName,
					initial: pendingValues.initial,
					address: {
						countryType: pendingValues.province ? true : false,
						country: {
							id: SelectedCountry.value,
							name: SelectedCountry.label,
							shortCode: SelectedCountry.shortCode,
						},
						province: pendingValues.province
							? {
								id: selectedProvinceOrState.value,
								name: selectedProvinceOrState.label,
								shortCode: selectedProvinceOrState.shortCode,
							}
							: undefined,
						states: pendingValues.state
							? {
								id: selectedProvinceOrState.value,
								name: selectedProvinceOrState.label,
								shortCode: selectedProvinceOrState.shortCode,
							}
							: undefined,
						addressLine1: pendingValues.addressLine1,
						city: pendingValues.city,
						postCode: pendingValues.postCode
							? pendingValues.postCode.replace(/[a-z]/g, (match: string) =>
								match.toUpperCase()
							)
							: undefined,
						zipCode: pendingValues.zipCode ? pendingValues.zipCode : undefined,
						email: pendingValues.email !== "" &&
							pendingValues.email ? pendingValues.email : undefined,
						phone: pendingValues.phone,
						fax: pendingValues.fax,
					},
					status: pendingValues.accountNo && pendingValues.accountNo !== null && pendingValues.accountNo !== "" ? 200 : 100,
					activateAccount: pendingValues.accountNo && pendingValues.accountNo !== null && pendingValues.accountNo !== "" ? false : true,
				};
				saveAccountOrBankDetailsFieldsData(payload);
			} catch {
			} finally {
				setIsPendingData(false);
			}
		}
	};

	const onSubmit = async (values: any) => {
		if (values.accountNo && values.accountNo !== null && values.accountNo !== "") {
			try {
				setIsPendingData(true)
				const verifyBank = await BankService.bankOrBranchExists(values.bankFinancialNo, values.branchTransitNumber);
				console.log("verifyBank", verifyBank)
				if (verifyBank && verifyBank.bankExist && verifyBank.branchExist) {
					const SelectedCountry = countryList.find(
						(e: any) => e.value === values.country
					);
					try {
						setIsPendingData(true);
						const ProvinceOrStateDDL = await AuthService.getProvinceOrStateDDL(
							SelectedCountry.value,
							SelectedCountry.countryType
						);
						const selectedProvinceOrState = values.province
							? ProvinceOrStateDDL.find((e: any) => e.value === values.province)
							: values.state
								? ProvinceOrStateDDL.find((e: any) => e.value === values.state)
								: undefined;

						let payload = {
							accTitle: values.accTitle,
							firstName: values.firstName,
							lastName: values.lastName,
							initial: values.initial,
							address: {
								countryType: values.province ? true : false,
								country: {
									id: SelectedCountry.value,
									name: SelectedCountry.label,
									shortCode: SelectedCountry.shortCode,
								},
								province: values.province
									? {
										id: selectedProvinceOrState.value,
										name: selectedProvinceOrState.label,
										shortCode: selectedProvinceOrState.shortCode,
									}
									: undefined,
								states: values.state
									? {
										id: selectedProvinceOrState.value,
										name: selectedProvinceOrState.label,
										shortCode: selectedProvinceOrState.shortCode,
									}
									: undefined,
								addressLine1: values.addressLine1,
								city: values.city,
								postCode: values.postCode
									? values.postCode.replace(/[a-z]/g, (match: string) =>
										match.toUpperCase()
									)
									: undefined,
								zipCode: values.zipCode ? values.zipCode : undefined,
								email: values.email !== "" &&
									values.email ? values.email : undefined,
								phone: values.phone,
								fax: values.fax,
							},
							status: values.accountNo && values.accountNo !== null && values.accountNo !== "" ? 200 : 100,
							activateAccount: values.accountNo && values.accountNo !== null && values.accountNo !== "" ? false : true,
						};
						saveAccountOrBankDetailsFieldsData(payload);
					} catch {
					} finally {
						setIsPendingData(false);
					}
				}
				if (verifyBank && !verifyBank.bankExist) {
					setSnackbarData({
						open: true,
						message: "Bank does not exist",
						severity: "error"
					})
				}
				if (verifyBank && verifyBank.bankExist && !verifyBank.branchExist) {
					setPendingValues(values);
					setOpenBranchAddedDialog(true);
				}

				setIsPendingData(false)
			}
			catch { setIsPendingData(false) }
		} else {

			const SelectedCountry = countryList.find(
				(e: any) => e.value === values.country
			);
			try {
				setIsPendingData(true);
				const ProvinceOrStateDDL = await AuthService.getProvinceOrStateDDL(
					SelectedCountry.value,
					SelectedCountry.countryType
				);
				const selectedProvinceOrState = values.province
					? ProvinceOrStateDDL.find((e: any) => e.value === values.province)
					: values.state
						? ProvinceOrStateDDL.find((e: any) => e.value === values.state)
						: undefined;

				let payload = {
					accTitle: values.accTitle,
					firstName: values.firstName,
					lastName: values.lastName,
					initial: values.initial,
					address: {
						countryType: values.province ? true : false,
						country: {
							id: SelectedCountry.value,
							name: SelectedCountry.label,
							shortCode: SelectedCountry.shortCode,
						},
						province: values.province
							? {
								id: selectedProvinceOrState.value,
								name: selectedProvinceOrState.label,
								shortCode: selectedProvinceOrState.shortCode,
							}
							: undefined,
						states: values.state
							? {
								id: selectedProvinceOrState.value,
								name: selectedProvinceOrState.label,
								shortCode: selectedProvinceOrState.shortCode,
							}
							: undefined,
						addressLine1: values.addressLine1,
						city: values.city,
						postCode: values.postCode
							? values.postCode.replace(/[a-z]/g, (match: string) =>
								match.toUpperCase()
							)
							: undefined,
						zipCode: values.zipCode ? values.zipCode : undefined,
						email: values.email !== "" &&
							values.email ? values.email : undefined,
						phone: values.phone,
						fax: values.fax,
					},
					status: values.accountNo && values.accountNo !== null && values.accountNo !== "" ? 200 : 100,
					activateAccount: values.accountNo && values.accountNo !== null && values.accountNo !== "" ? false : true,
				};

				// const bankPayload = {
				// 	accountNo: values.accountNo ?? undefined,
				// 	branchTransitNumber: values.branchTransitNumber ?? undefined,
				// 	bankFinancialNo: values.bankFinancialNo ?? undefined,
				// 	transactionAlertEmail: values.transactionAlertEmail ?? undefined,
				// };

				// await Promise.all([
				// 	saveAccountOrBankDetailsFieldsData(payload),
				// 	...(values.accountNo ? [saveBankDetailsFieldsData(bankPayload)] : []),
				// ]);

				saveAccountOrBankDetailsFieldsData(payload);

				// if (values.accountNo) {
				// 	saveBankDetailsFieldsData(bankPayload);
				// }
			} catch {
			} finally {
				setIsPendingData(false);
			}

			// let bankPayload = {
			// 	// Bank Info
			// 	accountNo: values.accountNo,
			// 	branchTransitNumber: values.branchTransitNumber,
			// 	bankFinancialNo: values.bankFinancialNo,
			// 	transactionAlertEmail: values.transactionAlertEmail,
			// }
			// saveBankDetailsFieldsData(bankPayload);
		}
	};

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		scrollPanelFieldsToTop();
		setTimeout(() => {
			formMethods.setValue("email", undefined)
		}, 1000)
		formMethods.setValue('accTitle', companyAccountantName)
		formMethods.setValue("country", defaultSelectedCountryState)
		// let path = `/account-bank-details`;
		// navigate(path);
	};

	return (
		<Grid>
			<BackdropCircularProgress
				open={isSubmitting || isPendingData || isPendingCoutryDDL || isSubmittingBankDetails}
				testId="yooo"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }} sx={{ paddingTop: "1rem" }}>
							<TwoColumnLayout
								toolbar={
									<></>
								}
								leftColumnContent={
									<>
										<StandardPanel
											title="Account Information"
											testId={`Account-Information`}
											variant="outlined"
											borderHide={true}
										>
											<AccountOrBankDetailsSetupFieldsPanel formMethods={formMethods} countryList={countryList} isLoadingData={(value: boolean) => setIsPendingData(value)}
												setDefaultSelectedCountry={(selectedCountry: any) => setDefaultSelectedCountryState(selectedCountry)}
											/>
										</StandardPanel>
									</>
								}
								rightColumnContent={
									<>
										<StandardPanel
											title="Bank Details"
											testId={`bank-details`}
											variant="outlined"
											borderHide={true}
										>
											<AccountantBankInfoSetupFieldsPanel onVerifyBankClickedHandler={() => setOpenverifyBankDialogue(true)} />
										</StandardPanel>
									</>
								}
								testId="t4-slip-setup-form"
								showToolbar={false}
							/>
							<AccountOrBankDetailsToolbar
								isSubmitting={false} onResetClickHandler={onResetClicked}
							/>
						</Grid>
					</Grid>
				</form>
			</FormProvider>
			<VerifyBankDialogue openVerifyBankDialogue={openVerifyBankDialogue} setOpenVerifyBankDialogue={(value: any) => setOpenverifyBankDialogue(value)} parentFormMethods={formMethods} />
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseBranchAddedHandler}
				open={openBranchAddedDialog}
				dialogContent={
					<Box>
						<Typography variant="body2" sx={{ mb: 2 }}>
							Account 1 Branch / Transit No. is not a valid code as listed in our current banking records. If you believe this is correct, please mail us.
						</Typography>
						<Typography variant="body2">
							Note: Penalty amount will be deducted for providing incorrect bank details.
						</Typography>
					</Box>
				}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseBranchAddedHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Ok"
							severity="success"
							raised
							onClickHandler={onConfirmBranchSubmit}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"security-questions-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
